/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VatType = exports.V3OrderItemOrderItemCategory = exports.V2OrderItemOrderItemCategory = exports.TranslatableType = exports.TransactionStatus = exports.SuspensionStatus = exports.SubscriptionType = exports.SubscriptionStatus = exports.SubscriptionSortBy = exports.SubscriptionFrequency = exports.SubdivisionType = exports.SortDirection = exports.ServiceAppendixType = exports.SegmentSegment = exports.RefundStatus = exports.RecurringPaymentStatusStatus = exports.RecurringPaymentCancellationDetailsInitiator = exports.PermissionType = exports.PaymentStatus = exports.PaymentEventEventType = exports.PagingType = exports.OrderType = exports.OrderStatusStatus = exports.OptimizeMode = exports.NotSuspendableReason = exports.Method = exports.MessageAppendixType = exports.Maturity = exports.Label = exports.JSType = exports.InitiatorEnumInitiator = exports.IdentityType = exports.Format = exports.FieldDescriptorProtoType = exports.Exposure = exports.CancellationInitiator = exports.CancelAt = exports.CallbackEventType = exports.CType = exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["NONE"] = "NONE";
    ActionType["SUSPEND"] = "SUSPEND";
    ActionType["RESUME"] = "RESUME";
    ActionType["MARK_AS_PAID"] = "MARK_AS_PAID";
    ActionType["CANCEL_NOW"] = "CANCEL_NOW";
    ActionType["CANCEL_NEXT_PAYMENT_DATE"] = "CANCEL_NEXT_PAYMENT_DATE";
    ActionType["UPDATE_VALID_UNTIL"] = "UPDATE_VALID_UNTIL";
    ActionType["UPDATE_FROM"] = "UPDATE_FROM";
    ActionType["UPDATE_FROM_AND_VALID_UNTIL"] = "UPDATE_FROM_AND_VALID_UNTIL";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var CallbackEventType;
(function (CallbackEventType) {
    CallbackEventType["UNKNOWN"] = "UNKNOWN";
    CallbackEventType["CREATED"] = "CREATED";
    CallbackEventType["UPDATED"] = "UPDATED";
    CallbackEventType["DELETED"] = "DELETED";
    CallbackEventType["ACTION"] = "ACTION";
})(CallbackEventType = exports.CallbackEventType || (exports.CallbackEventType = {}));
var CancelAt;
(function (CancelAt) {
    CancelAt["UNDEFINED"] = "UNDEFINED";
    CancelAt["IMMEDIATELY"] = "IMMEDIATELY";
    CancelAt["NEXT_PAYMENT_DATE"] = "NEXT_PAYMENT_DATE";
})(CancelAt = exports.CancelAt || (exports.CancelAt = {}));
var CancellationInitiator;
(function (CancellationInitiator) {
    CancellationInitiator["UNDEFINED"] = "UNDEFINED";
    CancellationInitiator["OWNER"] = "OWNER";
    CancellationInitiator["MEMBER"] = "MEMBER";
    CancellationInitiator["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
    CancellationInitiator["SETUP_FAILURE"] = "SETUP_FAILURE";
})(CancellationInitiator = exports.CancellationInitiator || (exports.CancellationInitiator = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var FieldDescriptorProtoType;
(function (FieldDescriptorProtoType) {
    FieldDescriptorProtoType["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    FieldDescriptorProtoType["TYPE_FLOAT"] = "TYPE_FLOAT";
    FieldDescriptorProtoType["TYPE_INT64"] = "TYPE_INT64";
    FieldDescriptorProtoType["TYPE_UINT64"] = "TYPE_UINT64";
    FieldDescriptorProtoType["TYPE_INT32"] = "TYPE_INT32";
    FieldDescriptorProtoType["TYPE_FIXED64"] = "TYPE_FIXED64";
    FieldDescriptorProtoType["TYPE_FIXED32"] = "TYPE_FIXED32";
    FieldDescriptorProtoType["TYPE_BOOL"] = "TYPE_BOOL";
    FieldDescriptorProtoType["TYPE_STRING"] = "TYPE_STRING";
    FieldDescriptorProtoType["TYPE_GROUP"] = "TYPE_GROUP";
    FieldDescriptorProtoType["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    FieldDescriptorProtoType["TYPE_BYTES"] = "TYPE_BYTES";
    FieldDescriptorProtoType["TYPE_UINT32"] = "TYPE_UINT32";
    FieldDescriptorProtoType["TYPE_ENUM"] = "TYPE_ENUM";
    FieldDescriptorProtoType["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    FieldDescriptorProtoType["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    FieldDescriptorProtoType["TYPE_SINT32"] = "TYPE_SINT32";
    FieldDescriptorProtoType["TYPE_SINT64"] = "TYPE_SINT64";
})(FieldDescriptorProtoType = exports.FieldDescriptorProtoType || (exports.FieldDescriptorProtoType = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
})(Format = exports.Format || (exports.Format = {}));
var IdentityType;
(function (IdentityType) {
    IdentityType["UNDEFINED"] = "UNDEFINED";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["CONTACT"] = "CONTACT";
})(IdentityType = exports.IdentityType || (exports.IdentityType = {}));
var InitiatorEnumInitiator;
(function (InitiatorEnumInitiator) {
    InitiatorEnumInitiator["UNDEFINED"] = "UNDEFINED";
    InitiatorEnumInitiator["OWNER"] = "OWNER";
    InitiatorEnumInitiator["MEMBER"] = "MEMBER";
})(InitiatorEnumInitiator = exports.InitiatorEnumInitiator || (exports.InitiatorEnumInitiator = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
    Maturity["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var MessageAppendixType;
(function (MessageAppendixType) {
    MessageAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    MessageAppendixType["AUTO_VELO"] = "AUTO_VELO";
    MessageAppendixType["DOCS_CONF"] = "DOCS_CONF";
    MessageAppendixType["MULTILINGUAL"] = "MULTILINGUAL";
})(MessageAppendixType = exports.MessageAppendixType || (exports.MessageAppendixType = {}));
var Method;
(function (Method) {
    Method["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    Method["CREATE"] = "CREATE";
    Method["GET_ITEM"] = "GET_ITEM";
    Method["UPDATE"] = "UPDATE";
    Method["DELETE"] = "DELETE";
    Method["UPSERT"] = "UPSERT";
    Method["LIST"] = "LIST";
    Method["QUERY"] = "QUERY";
    Method["BULK_CREATE"] = "BULK_CREATE";
    Method["BULK_UPDATE"] = "BULK_UPDATE";
    Method["BULK_UPDATE_BY_FILTER"] = "BULK_UPDATE_BY_FILTER";
    Method["BULK_DELETE"] = "BULK_DELETE";
    Method["BULK_DELETE_BY_FILTER"] = "BULK_DELETE_BY_FILTER";
    Method["BULK_UPSERT"] = "BULK_UPSERT";
})(Method = exports.Method || (exports.Method = {}));
var NotSuspendableReason;
(function (NotSuspendableReason) {
    NotSuspendableReason["UNDEFINED"] = "UNDEFINED";
    NotSuspendableReason["PENDING"] = "PENDING";
    NotSuspendableReason["TRIAL"] = "TRIAL";
    NotSuspendableReason["CANCELED"] = "CANCELED";
    NotSuspendableReason["EXPIRED"] = "EXPIRED";
    NotSuspendableReason["DRAFT"] = "DRAFT";
    NotSuspendableReason["ALREADY_SUSPENDED"] = "ALREADY_SUSPENDED";
    NotSuspendableReason["OLD_STRIPE"] = "OLD_STRIPE";
})(NotSuspendableReason = exports.NotSuspendableReason || (exports.NotSuspendableReason = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var OrderStatusStatus;
(function (OrderStatusStatus) {
    OrderStatusStatus["UNDEFINED"] = "UNDEFINED";
    OrderStatusStatus["INITIALIZED"] = "INITIALIZED";
    OrderStatusStatus["IN_PROCESS"] = "IN_PROCESS";
    OrderStatusStatus["EXPIRED"] = "EXPIRED";
    OrderStatusStatus["NOT_APPROVED"] = "NOT_APPROVED";
    OrderStatusStatus["APPROVED"] = "APPROVED";
    OrderStatusStatus["SUBSCRIPTION_ACTIVE"] = "SUBSCRIPTION_ACTIVE";
    OrderStatusStatus["SUBSCRIPTION_CANCELLED"] = "SUBSCRIPTION_CANCELLED";
    OrderStatusStatus["SUBSCRIPTION_FINISHED"] = "SUBSCRIPTION_FINISHED";
    OrderStatusStatus["SUBSCRIPTION_PENDING"] = "SUBSCRIPTION_PENDING";
    OrderStatusStatus["SUBSCRIPTION_SUSPENDED"] = "SUBSCRIPTION_SUSPENDED";
})(OrderStatusStatus = exports.OrderStatusStatus || (exports.OrderStatusStatus = {}));
var OrderType;
(function (OrderType) {
    OrderType["UNDEFINED"] = "UNDEFINED";
    OrderType["ONE_TIME"] = "ONE_TIME";
    OrderType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var PagingType;
(function (PagingType) {
    PagingType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    PagingType["OFFSET"] = "OFFSET";
    PagingType["CURSOR"] = "CURSOR";
})(PagingType = exports.PagingType || (exports.PagingType = {}));
var PaymentEventEventType;
(function (PaymentEventEventType) {
    PaymentEventEventType["UNDEFINED"] = "UNDEFINED";
    PaymentEventEventType["TRANSACTION_STATUS_CHANGED"] = "TRANSACTION_STATUS_CHANGED";
    PaymentEventEventType["REFUND_STATUS_CHANGED"] = "REFUND_STATUS_CHANGED";
    PaymentEventEventType["RECURRING_PAYMENT_STATUS_CHANGED"] = "RECURRING_PAYMENT_STATUS_CHANGED";
    PaymentEventEventType["TRANSACTION_UPDATED"] = "TRANSACTION_UPDATED";
    PaymentEventEventType["TRANSACTION_CREATED"] = "TRANSACTION_CREATED";
})(PaymentEventEventType = exports.PaymentEventEventType || (exports.PaymentEventEventType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNDEFINED"] = "UNDEFINED";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatus["PENDING"] = "PENDING";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PermissionType;
(function (PermissionType) {
    PermissionType["AUTO"] = "AUTO";
    PermissionType["MANUAL"] = "MANUAL";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
var RecurringPaymentCancellationDetailsInitiator;
(function (RecurringPaymentCancellationDetailsInitiator) {
    RecurringPaymentCancellationDetailsInitiator["UNDEFINED"] = "UNDEFINED";
    RecurringPaymentCancellationDetailsInitiator["BUYER"] = "BUYER";
    RecurringPaymentCancellationDetailsInitiator["MERCHANT"] = "MERCHANT";
    RecurringPaymentCancellationDetailsInitiator["PAYMENT"] = "PAYMENT";
    RecurringPaymentCancellationDetailsInitiator["SETUP"] = "SETUP";
})(RecurringPaymentCancellationDetailsInitiator = exports.RecurringPaymentCancellationDetailsInitiator || (exports.RecurringPaymentCancellationDetailsInitiator = {}));
var RecurringPaymentStatusStatus;
(function (RecurringPaymentStatusStatus) {
    RecurringPaymentStatusStatus["UNDEFINED"] = "UNDEFINED";
    RecurringPaymentStatusStatus["PENDING"] = "PENDING";
    RecurringPaymentStatusStatus["ACTIVE"] = "ACTIVE";
    RecurringPaymentStatusStatus["CANCELLED"] = "CANCELLED";
    RecurringPaymentStatusStatus["FINISHED"] = "FINISHED";
    RecurringPaymentStatusStatus["SUSPENDED"] = "SUSPENDED";
})(RecurringPaymentStatusStatus = exports.RecurringPaymentStatusStatus || (exports.RecurringPaymentStatusStatus = {}));
var RefundStatus;
(function (RefundStatus) {
    RefundStatus["UNDEFINED"] = "UNDEFINED";
    RefundStatus["APPROVED"] = "APPROVED";
    RefundStatus["PENDING"] = "PENDING";
    RefundStatus["DECLINED"] = "DECLINED";
})(RefundStatus = exports.RefundStatus || (exports.RefundStatus = {}));
var SegmentSegment;
(function (SegmentSegment) {
    SegmentSegment["UNSPECIFIED"] = "UNSPECIFIED";
    SegmentSegment["USERS"] = "USERS";
    SegmentSegment["PUBLIC"] = "PUBLIC";
    SegmentSegment["OTHERS"] = "OTHERS";
})(SegmentSegment = exports.SegmentSegment || (exports.SegmentSegment = {}));
var ServiceAppendixType;
(function (ServiceAppendixType) {
    ServiceAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    ServiceAppendixType["NILE"] = "NILE";
    ServiceAppendixType["MESSAGE_BUS"] = "MESSAGE_BUS";
})(ServiceAppendixType = exports.ServiceAppendixType || (exports.ServiceAppendixType = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType = exports.SubdivisionType || (exports.SubdivisionType = {}));
var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency = exports.SubscriptionFrequency || (exports.SubscriptionFrequency = {}));
var SubscriptionSortBy;
(function (SubscriptionSortBy) {
    SubscriptionSortBy["UNDEFINED"] = "UNDEFINED";
    SubscriptionSortBy["DATE_CREATED"] = "DATE_CREATED";
    SubscriptionSortBy["EXPIRATION_DATE"] = "EXPIRATION_DATE";
})(SubscriptionSortBy = exports.SubscriptionSortBy || (exports.SubscriptionSortBy = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["UNDEFINED"] = "UNDEFINED";
    SubscriptionStatus["DRAFT"] = "DRAFT";
    SubscriptionStatus["PENDING"] = "PENDING";
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["EXPIRED"] = "EXPIRED";
    SubscriptionStatus["CANCELED"] = "CANCELED";
    SubscriptionStatus["PENDING_CANCELLATION"] = "PENDING_CANCELLATION";
    SubscriptionStatus["SUSPENDED"] = "SUSPENDED";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["UNDEFINED"] = "UNDEFINED";
    SubscriptionType["ONLINE"] = "ONLINE";
    SubscriptionType["OFFLINE"] = "OFFLINE";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
var SuspensionStatus;
(function (SuspensionStatus) {
    SuspensionStatus["UNDEFINED"] = "UNDEFINED";
    SuspensionStatus["ACTIVE"] = "ACTIVE";
    SuspensionStatus["ENDED"] = "ENDED";
})(SuspensionStatus = exports.SuspensionStatus || (exports.SuspensionStatus = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["UNDEFINED"] = "UNDEFINED";
    TransactionStatus["APPROVED"] = "APPROVED";
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["PENDING_MERCHANT"] = "PENDING_MERCHANT";
    TransactionStatus["CANCELED"] = "CANCELED";
    TransactionStatus["DECLINED"] = "DECLINED";
    TransactionStatus["REFUNDED"] = "REFUNDED";
    TransactionStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    TransactionStatus["AUTHORIZED"] = "AUTHORIZED";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
var TranslatableType;
(function (TranslatableType) {
    TranslatableType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    TranslatableType["SHORT_TEXT"] = "SHORT_TEXT";
    TranslatableType["LONG_TEXT"] = "LONG_TEXT";
    TranslatableType["RICH_TEXT"] = "RICH_TEXT";
    TranslatableType["RICH_CONTENT_EDITOR"] = "RICH_CONTENT_EDITOR";
    TranslatableType["SELECTION"] = "SELECTION";
    TranslatableType["MULTI_SELECTION"] = "MULTI_SELECTION";
    TranslatableType["DOCUMENT"] = "DOCUMENT";
    TranslatableType["IMAGE"] = "IMAGE";
    TranslatableType["VIDEO"] = "VIDEO";
})(TranslatableType = exports.TranslatableType || (exports.TranslatableType = {}));
var V2OrderItemOrderItemCategory;
(function (V2OrderItemOrderItemCategory) {
    V2OrderItemOrderItemCategory["UNDEFINED"] = "UNDEFINED";
    V2OrderItemOrderItemCategory["PHYSICAL"] = "PHYSICAL";
    V2OrderItemOrderItemCategory["DIGITAL"] = "DIGITAL";
})(V2OrderItemOrderItemCategory = exports.V2OrderItemOrderItemCategory || (exports.V2OrderItemOrderItemCategory = {}));
var V3OrderItemOrderItemCategory;
(function (V3OrderItemOrderItemCategory) {
    V3OrderItemOrderItemCategory["UNDEFINED"] = "UNDEFINED";
    V3OrderItemOrderItemCategory["PHYSICAL"] = "PHYSICAL";
    V3OrderItemOrderItemCategory["DIGITAL"] = "DIGITAL";
})(V3OrderItemOrderItemCategory = exports.V3OrderItemOrderItemCategory || (exports.V3OrderItemOrderItemCategory = {}));
var VatType;
(function (VatType) {
    VatType["UNSPECIFIED"] = "UNSPECIFIED";
    VatType["CPF"] = "CPF";
    VatType["CNPJ"] = "CNPJ";
})(VatType = exports.VatType || (exports.VatType = {}));
//# sourceMappingURL=types.js.map